<template>
  <div class="home-content">
    <div class="head-select">
      <el-input v-model="searchval" placeholder="请输入机器名称、编号等" class="search-input"></el-input>
      <el-select v-model="selectval" placeholder="请选择搜索类型" class="search-select">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
      <el-button type="primary" class="search-button" @click="allint2">批量导入</el-button>
      <el-button type="primary" class="search-button" @click="exportExcel">
        导出excel
      </el-button>
      <el-button type="primary" class="add-button" @click="add">
        新增
      </el-button>
      <el-button type="danger" class="del-button" @click="delMulti">
        删除
      </el-button>
    </div>
    <div class="machine-content">
      <div class="list-con">
        <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key">
            <template slot-scope="scope">
              <div class="text" v-if="!slotmap.includes(item.key)">
                {{ scope.row[item.key] }}
              </div>
              <div class="text" v-else-if="item.key == 'product'">
                {{ scope.row[item.key] ? scope.row[item.key]["name"] : '' }}
              </div>
              <div class="text" v-else-if="item.key == 'team'">
                {{ scope.row[item.key] ? scope.row[item.key]["name"] : '' }}
              </div>
              <div class="text" v-else-if="item.key == 'device_id'">
                {{ getscheme(scope.row.device_id) }}
              </div>
              <div v-else-if="item.key == 'menu'" class="tab-menu">
                <div class="edit" @click="edit(scope.row)">编辑</div>
                <div class="line"></div>
                <div class="delbtn" @click="delSingle(scope.row)">删除</div>
                <div class="line"></div>
                <el-button @click="lookImg(scope.row)" type="success" size="mini">查看二维码</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :total="numdata"
        style="margin-top: 30px; float: right; margin-right: 60px" :current-page="current_page" :page-size="page_size"
        @current-change="handleCurrentChange" @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addvisible" :modal-append-to-body="true" custom-class="edit-dialog" @close="dialogclose"
      :destroy-on-close="true" :close-on-click-modal="false" width="720px">
      <div slot="title">{{ formData.id > 0 ? "编辑" : "新增" }}</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">机器名称</div>
          <el-input class="edit-input" v-model="formData.name" placeholder="请输入机器名称"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">设备选择</div>
          <el-select class="edit-input" v-model="formData.device_id" placeholder="请选择设备" @change="devicechange">
            <el-option v-for="item in devicelist" :key="item.id" :label="item.device_name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="edit-item">
          <div class="text">产品类型</div>
          <el-select class="edit-input" v-model="formData.product_id" placeholder="请选择产品类型">
            <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="edit-item">
          <div class="text">机器编号</div>
          <el-input class="edit-input" v-model="formData.sn" placeholder="请输入机器编号"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">所属生产组</div>
          <el-select class="edit-input" v-model="formData.team_id" placeholder="请输入所属生产组">
            <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="edit-item">
          <div class="text">备注</div>
          <el-input class="edit-input" v-model="formData.remark" placeholder="请输入备注"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose">取消</el-button>
          <el-button type="primary" size="small" @click="adds">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="imgDialogVisible" width="50%" center>
      <div class="looks">
        <div class="tt">
          <img src="@/assets/icon/icon_1.jpg" alt="" class="button-icon" />
          <div class="r_txt">
            <span>创建成功</span>
            <label>请点击下方按钮下载二维码</label>
          </div>
        </div>
        <div class="cons" v-if="jsonDialog">
          <div class="cons_l">
            <div class="single">机器名称：</div>
            <div class="single">{{ jsonDialog.name }}</div>
            <div class="single">机器类型：</div>
            <div class="single">{{ jsonDialog.product_name }}</div>
            <div class="single">机器编号：</div>
            <div class="single">{{ jsonDialog.sn }}</div>
            <div class="single">所属生产组：</div>
            <div class="single">{{ jsonDialog["team_name"] }}</div>
          </div>
          <div class="cons_r">
            <div class="img_infor">
              <img :src="imgDialogUrl" alt="" />
              <span>复制设备信息</span>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button style="background:#507AF9" type="primary" @click="downloadImg">下载二维码</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { delMachines, getProductLists, editMachines, addMachines, getGrouupLists, sewingMachineList, getDeviceList, exportMachine } from "../../api/index";
import datajson from './data1.json'
const XLSX = require('xlsx')
export default {
  data() {
    return {
      datajson,
      vindex: 0,
      activeName: "first",
      timer1: "",
      searchval: "",
      selectval: "sn",
      options: [
        { label: "机器编号", value: "sn" },
        { label: "机器名称", value: "name" },
      ],
      dataSource: [
        { label: "机器名称", key: "name" },
        { label: "机器类型", key: "product" },
        { label: "机器编号", key: "sn" },
        { label: "设备编号", key: "device_id" },
        { label: "所属生产组", key: "team" },
        { label: "操作", key: "menu" },
      ],
      tabelData: [],
      slotmap: ["menu", "product", "team", "device_id"],
      numdata: 0,
      current_page: 1,
      page_size: 10,
      addvisible: false,
      formData: {
        id: 0,
        name: "",
        team_id: "",
        sn: "",
        product_id: "",
        remark: "",
        device_id: ""
      },
      teamList: [],//缝纫机列表
      productList: [],//类型列表
      delList: [],//删除列表
      imgDialogVisible: false,
      imgDialogUrl: "",
      jsonDialog: {},
      imgUrl: "https://fmadmin.sewme.cn",//图片网址
      devicelist: [],
      scheme_id: '',
      jsondata: [],
    };
  },
  methods: {
    downloadImg() {
      this.downloadByBlob(this.imgDialogUrl, '二维码')
    },
    // 下载图片
    downloadByBlob(url, name) {
      let image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      image.onload = () => {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        canvas.toBlob((blob) => {
          let url = URL.createObjectURL(blob)
          this.download(url, name)
          // 用完释放URL对象
          URL.revokeObjectURL(url)
        })
      }
    },
    download(href, name) {
      let eleLink = document.createElement('a')
      eleLink.download = name
      eleLink.href = href
      eleLink.click()
      eleLink.remove()
    },
    lookImg(row) {
      if (!row.image) {
        this.$message.warning("暂未生成二维码!");
        return;
      }
      this.imgDialogVisible = true;
      this.jsonDialog = row;
      this.jsonDialog.product_name = this.jsonDialog.product.name;
      this.jsonDialog.team_name = this.jsonDialog.team.name;
      this.imgDialogUrl = this.imgUrl + row.image;
    },
    delMulti() {
      if (this.delList.length == 0) {
        this.$message.warning("请选择要删除的缝纫机!");
        return;
      }
      this.$confirm(
        '确认删除选择的缝纫机吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms = {
          ids: this.delList,
        }
        delMachines(forms).then(res => {
          if (res.code == 1) {
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.delList = [];
            this.getData();
          } else {
            this.$message.warning("删除失败!");
          }
        });
      }).catch((err) => {
        Message.warning('取消操作');
      })
    },
    delSingle(row) {
      this.$confirm(
        '确认删除该缝纫机吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms = {
          ids: [row.id],
        }
        delMachines(forms).then(res => {
          if (res.code == 1) {
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.getData();
          } else {
            this.$message.warning("删除失败!");
          }
        });
      }).catch((err) => {
        Message.warning('取消操作');
      })
    },
    getProductList() {
      let params = {
        limit: 1000,
        page: 1,
        scheme_id: this.scheme_id
      };
      getProductLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.productList = res.data;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //添加修改用户
    adds() {
      if (!this.formData.name) {
        this.$message.warning("机器名称不能为空!");
        return;
      }
      if (!this.formData.product_id) {
        this.$message.warning("产品类型不能为空!");
        return;
      }
      if (!this.formData.device_id) {
        this.$message.warning("设备不能为空!");
        return;
      }
      if (!this.formData.sn) {
        this.$message.warning("机器编号不能为空!");
        return;
      }
      if (!this.formData.team_id) {
        this.$message.warning("请选择所属生产组!");
        return;
      }
      if (this.formData.id == 0) {
        addMachines(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("添加成功!");
              this.getData();
            } else {
              this.$message.error("添加失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        editMachines(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("修改成功!");
              this.getData();
            } else {
              this.$message.error("编辑失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    cleardata() {
      this.formData = {
        id: 0,
        name: "",
        team_id: "",
        sn: "",
        product_id: "",
        remark: "",
        device_id: ""
      }
    },
    getTeamList() {
      let params = {
        limit: 1000,
        page: 1,
      };
      getGrouupLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.teamList = res.data.list;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogclose() {
      this.cleardata()
      this.addvisible = false;
    },
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData();
    },
    getData() {
      let params = {};
      if (this.selectval == "sn") {
        params = {
          limit: this.page_size,
          page: this.current_page,
          "search[0][field]": "sn",
          "search[0][val]": this.searchval,
          "search[0][operator]": "LIKE",
        };
      } else {
        params = {
          limit: 10,
          page: this.current_page,
          "search[1][field]": "name",
          "search[1][val]": this.searchval,
          "search[1][operator]": "LIKE",
        };
      }
      sewingMachineList(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            console.log(res);
            this.numdata = res.data.total;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page = 1;
      this.getData();
    },
    handleClick(active) { },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delList = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        this.delList.push(this.multipleSelection[i].id);
      }

    },
    add() {
      this.addvisible = true;
    },
    del() { },
    edit(row) {
      console.log('___edit', row)
      this.formData = {
        id: row.id,
        name: row.name,
        team_id: row.team_id,
        sn: row.sn,
        product_id: row.product_id,
        remark: row.remark,
        device_id: row.device_id,
      };
      this.scheme_id = row.product.scheme_id
      this.getProductList()
      this.addvisible = true;
    },
    devicechange(e) {
      this.scheme_id = this.devicelist.find(item => item.id == e).scheme_id
      this.getProductList()
    },
    itemdel() { },
    getdevicelist() {
      let params = {
        limit: 9999,
        page: 1,
        "search[0][field]": "sn",
        "search[0][val]": this.searchval,
        "search[0][operator]": 'LIKE',
      };
      getDeviceList(params)
        .then((res) => {
          if (res.code == 1) {
            this.devicelist = res.data.list;
            console.log('___table', this.devicelist)
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getscheme(id) {
      let sname = ''
      const scheme = this.devicelist.find(item => item.id == id)
      console.log()
      if (scheme) {
        sname = scheme.device_name
      } else {
        sname = '未绑定'
      }
      return sname
    },
    getAllmechine() {
      const params = {
        limit: 99999,
        page: 1
      };
      sewingMachineList(params).then(res => {
        let newlist = []
        newlist = res.data.list.map(item => {
          return {
            '机器名称': item.name,
            '机器类型': item.product ? item.product.name : '',
            '机器编号': item.sn,
            '所属生产组': item.team.name,
            '机器id': item.uuid
          }
        })
        console.log('____mechine', JSON.stringify(newlist))
      })
    },
    addmecccc() {
    },
    allint2() {
      // 检查 XLSX 是否加载成功
      if (!XLSX) {
        this.$message.error('XLSX 库加载失败');
        return;
      }
      
      // 创建文件输入元素
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls';
      
      // 监听文件选择
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        // 检查文件类型
        if (!file.name.match(/\.(xlsx|xls)$/i)) {
          this.$message.warning('请选择 Excel 文件');
          return;
        }
        
        // 创建 FileReader
        const reader = new FileReader();
        
        // 读取文件完成时的回调
        reader.onload = (e) => {
          try {
            // 检查 e.target.result 是否存在
            if (!e.target.result) {
              throw new Error('文件读取结果为空');
            }
            
            // 使用 xlsx 库解析 excel 文件
            const workbook = XLSX.read(e.target.result, { type: 'binary' });
            
            // 获取第一个工作表
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // 转换为 JSON 格式
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            
            console.log('Excel 数据解析成功:', jsonData);
            this.$message.success('文件读取成功，共解析 ' + jsonData.length + ' 条数据');
            
            // 这里可以根据需要处理解析的数据
            // 例如：批量添加用户
            this.processExcelData(jsonData);
          } catch (error) {
            console.error('文件读取失败:', error);
            this.$message.error('文件读取失败: ' + error.message);
          }
        };
        
        // 读取文件为二进制字符串
        reader.readAsBinaryString(file);
      };
      
      // 触发文件选择对话框
      input.click();
    },
    processExcelData(data) {
      // 处理解析后的 Excel 数据
      // 这里可以根据实际 Excel 表格的结构进行调整
      if (!data.length) return
      this.jsondata = []
      data.forEach((item, index) => {
        // 假设 Excel 表格包含以下列：mobile, name, team_id
        let formData = {
          device_id: item.device_id ||'',
          name: item.name || '',
          product_id: item.product_id || '',
          sn: item.sn,
          team_id: item.team_id
        };
        this.jsondata.push(formData)
        console.log('准备添加设备:', formData);
      });
      this.allint()
    },
    allint() {
      if (this.vindex < this.jsondata.length) {
        let vdata = this.jsondata[this.vindex]
        let formData = {
          device_id: vdata.device_id,
          name: vdata.name,
          product_id: vdata.product_id,
          remark: '',
          sn: vdata.sn,
          team_id: vdata.team_id
        }
        addMachines(formData).then((res) => {
          if (res.code == 1) {
            this.$message.success(`设备添加进度:${this.vindex+1}/${this.jsondata.length}`);
          } else {
            this.$message.warning(`第${this.vindex+1}添加失败：${res.msg}`);
          }
          setTimeout(() => {
            this.vindex += 1
            this.allint()
          }, 500);
        })
      } else {
        return
      }

    },
    exportExcel() {
			let token = sessionStorage.getItem("token")
      const url = `https://fmadmin.sewme.cn/index.php/admin/Machine/exportExcel?limit=9999&page=1&batoken=${token}`
      window.open(url, '_blank');
    }
  },
  mounted() {
    this.getProductList();
    this.getTeamList();
    this.getData();
    this.getdevicelist()
    this.getAllmechine()
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  height: calc(100% - 64px);

  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;

    .el-date-editor {
      margin-left: 16px;
      width: 185px;
    }
  }

  .search-input {
    width: 245px;
  }

  .search-select {
    width: 185px;
    margin-left: 16px;
  }

  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;

    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }

  .add-button {
    margin-left: auto;
  }

  .del-button {
    margin-right: 125px;
  }

  .machine-content {
    padding: 0 28px;
    height: calc(100% - 88px);
    background: #fff;
  }

  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }

  .tab-menu {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }

  .edit {
    cursor: pointer;
    color: #507af9;
  }

  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
</style>
<style lang="scss">
.list-con {
  padding-top: 30px;

  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}

.looks {
  overflow: hidden;
}

.looks .tt {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
}

.looks .tt img {
  float: left;
  height: 55px;
  display: block;
  margin-top: 20px;
}

.looks .tt .r_txt {
  width: 80%;
  float: left;
  margin-left: 20px;
}

.looks .tt .r_txt span {
  color: #2F3338;
  font-size: 24px;
  display: block;
  margin: 15px 0;
  margin-top: 0px;
}

.looks .tt .r_txt label {
  color: #8F96A0;
  font-size: 24px;
  display: block;
  margin: 15px 0;
}

.looks .cons {
  overflow: hidden;
  width: 90%;
  margin: 0 auto;
  background: #F6F7F9;
  border-radius: 5px;
  margin-top: 20px;
  padding: 30px 0;
}

.looks .cons .cons_l {
  float: left;
  width: 50%;
  overflow: hidden;
  margin-left: 10%;
}

.looks .cons .cons_l .single {
  float: left;
  width: 50%;
  overflow: hidden;
  color: #585C61;
  font-size: 18px;
  line-height: 30px;
  padding: 10px 0;
}

.looks .cons .cons_r {
  float: left;
  width: 30%;
  margin-right: 10%;
  overflow: hidden;
}

.looks .cons .cons_r img {
  width: 150px;
  display: block;
  border: solid 5px #fff;
}

.looks .cons .cons_r span {
  display: block;
  width: 100%;
  text-align: center;
  color: #507AF9;
  font-size: 16px;
  margin-top: 10px;
}

.looks .cons .cons_r .img_infor {
  width: 160px;
  display: block;
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
}
</style>